import { Fragment } from 'react';
import { Badge } from 'reactstrap';

import Field from 'Lib/components/form/Field';
import Form from 'Lib/components/form/Form';
import { default as CommonMultiSelect } from 'Lib/components/form/MultiSelect';

import { useFilter } from './useFilter';

function MultiSelect(props) {
    const { options, context } = props;

    const handleClear = form => {
        if (form) {
            form.setFieldValue('options', null);
        }
        context.setFilterValue(props.name, null);
        setValue(null);
    };

    const handleCancel = () => {
        handleToggle();
    };

    const filter = useFilter(
        props,
        () => {
            const options = props.context.getFilterValue(props.name);

            if (options) {
                bindValues(options);
            }
        },
        handleClear,
        handleCancel
    );
    const { value, setValue, handleToggle, setFilterValue, renderMenuButtons } = filter;

    const handleSubmit = values => {
        let label = null;

        if (!values.options) {
            setValue(null);
            return;
        }

        const filterValues = [];
        values.options.forEach(option => {
            filterValues.push(option.value);
        });

        label = renderLabel(values.options);

        setValue({ value: values.options, label: label });
        setFilterValue(props.name, filterValues);
        handleToggle();
    };

    const handleChange = (options, form, field) => {
        form.setFieldValue(field.name, options);
    };

    const renderLabel = selectedOptions => {
        if (!selectedOptions) {
            return null;
        }

        if (selectedOptions.length == 0) {
            return 0;
        }

        const labelComponents = [];
        selectedOptions.forEach(option => {
            labelComponents.push(
                <li>
                    <Badge color="info">{option.label}</Badge>
                </li>
            );
        });

        return (
            <ul
                className="list list-badges"
                style={{
                    display: 'inline-block'
                }}
            >
                {labelComponents.map((item, itemIndex) => {
                    return <Fragment key={itemIndex}>{item}</Fragment>;
                })}
            </ul>
        );
    };

    const bindValues = selectedOptions => {
        if (!selectedOptions) {
            return;
        }

        if (!Array.isArray(selectedOptions)) {
            selectedOptions = [selectedOptions];
        }

        if (selectedOptions.length == 0) {
            return;
        }

        const foundOptions = options.filter(option => selectedOptions?.find(val => option.value == val));

        if (foundOptions.length == 0) {
            return;
        }

        setValue({ value: foundOptions, label: renderLabel(foundOptions) });
    };

    return filter.render(
        <div
            className="searchable-list-filter-menu"
            style={{
                padding: '10px',
                minWidth: '300px'
            }}
        >
            <Form
                initialValues={{
                    options: value ? value.value : null
                }}
                onSubmit={handleSubmit}
                render={form => (
                    <form onSubmit={form.handleSubmit}>
                        <Field
                            name="options"
                            label="Options"
                            type="select"
                            hideLabel={true}
                            render={({ field }) => (
                                <CommonMultiSelect
                                    name={field.name}
                                    options={options}
                                    onChange={options => {
                                        handleChange(options, form, field);
                                    }}
                                    value={field.value}
                                />
                            )}
                        />
                        {renderMenuButtons({ handleCancel, handleClear, form })}
                    </form>
                )}
            />
        </div>
    );
}

export default MultiSelect;
